// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import HomePage from './Views/HomePage';
import LandingPage from './Views/LandingPage';
import Profile from './Views/Profile';
import LiveAuctions from './Views/LiveAuctions';
import PcaLanding from './Views/PcaLanding';
import CarPage from './Views/CarPage';
import MarketDashboard from './Views/MarketDashboard';
import AdminPage from './Views/AdminPage';
import PrivacyPolicy from './Views/PrivacyPolicy';
import TermsOfService from './Views/TermsOfService';
import DoNotSell from './Views/DoNotSell';
import Subscribe from './Views/Subscribe';
import { SignIn, SignUp, Show } from "@clerk/react";
import usePaidPlan from './hooks/usePaidPlan';

function RequirePlan({ children }) {
  const { hasPaidPlan, isLoaded } = usePaidPlan();
  if (!isLoaded) return null;
  return hasPaidPlan ? children : <Navigate to="/subscribe" replace />;
}

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Show when="signed-in"><RequirePlan><HomePage /></RequirePlan></Show>
                <Show when="signed-out"><LandingPage /></Show>
              </>
            }
          />
          <Route path="/car/:modelId" element={<CarPage />} />
          <Route path="/dashboard" element={<MarketDashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/live-auctions" element={<LiveAuctions />} />
          <Route path="/pca" element={<PcaLanding />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/do-not-sell" element={<DoNotSell />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/sign-in" element={<SignIn routing="hash" forceRedirectUrl="/" />} />
          <Route path="/sign-up" element={<SignUp routing="hash" forceRedirectUrl="/subscribe" signInForceRedirectUrl="/" />} />
          {/* Add more routes here as needed */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
